/* =============================================================================
 * M.M.LaFleur — "Shop this look" drawer: size selects and add-all wiring,
 * plus the per-photo looks (v4.7.9).
 *
 * Loaded from sections/mm_footer.liquid.
 *
 * mm-editorial.js already owns the Add to bag click — it reads the variant id
 * straight off `data-mm-look-add` — so rather than duplicate cart logic, this
 * script only ever WRITES that attribute. Choosing a size fills it in and
 * enables the button; everything after that is the existing handler's job.
 *
 * The same trick covers Add all: `data-mm-look-add-all` is a comma-separated
 * list read by the same file, recomputed here from whatever each row has
 * currently selected. Since v4.7.9 there can be several drawers on a PDP (one
 * per look), so Add all is worked out per drawer, from that drawer's rows.
 *
 * PER-PHOTO LOOKS (v4.7.9 — snippets/mm_looks.liquid)
 *   Buttons:  [data-mm-looks-open="<look id>"] on a gallery frame.
 *   Drawers:  rendered inert inside <template data-mm-looks-tpl> (in the
 *             gallery, so they cost nothing until used) and moved next to the
 *             gallery the first time one is opened. Same .mm-look markup and
 *             styling as the original drawer; open/close, focus trap, Escape
 *             and focus return are handled here because mm-editorial.js only
 *             knows the single [data-mm-look] drawer.
 *
 * PREVIEW SWITCH. While the section's "Show 'Shop this look' drawer" box is
 * off, the per-photo buttons are rendered with `hidden data-mm-looks-preview`.
 * ?mm_looks=1 on any URL turns preview on for this browser tab
 * (sessionStorage), which un-hides them; ?mm_looks=0 turns it off again.
 * Nothing changes for shoppers, who never have the flag.
 * ========================================================================== */

(function () {
  "use strict";

  /* Platter re-injects the footer's scripts around a Barba container swap. */
  if (window.__mmLookSizeBound) return;
  window.__mmLookSizeBound = true;

  var PANELS = "[data-mm-look], [data-mm-looks-panel]";

  /* Add all only offers what is actually addable. A row still waiting on a
     size contributes nothing rather than defaulting to a guess — the whole
     point of the select is that nobody ends up with 00 by accident. */
  function refreshPanel(panel) {
    var all = panel.querySelector("[data-mm-look-add-all]");
    if (!all) return;

    var ids = [];
    var waiting = 0;

    Array.prototype.forEach.call(panel.querySelectorAll("[data-mm-look-item]"), function (row) {
      var btn = row.querySelector("[data-mm-look-add]");
      if (!btn) return;
      var id = btn.getAttribute("data-mm-look-add");
      if (id) {
        ids.push(id);
      } else if (row.querySelector("[data-mm-look-select]")) {
        waiting += 1;
      }
    });

    all.setAttribute("data-mm-look-add-all", ids.join(","));
    all.disabled = ids.length === 0;

    /* Say why the button is doing less than its label implies, rather than
       letting it silently add a subset. */
    var note = panel.querySelector("[data-mm-look-note]");
    if (note) {
      if (waiting > 0) {
        note.textContent = waiting === 1
          ? "Choose a size for 1 more piece to add everything."
          : "Choose a size for " + waiting + " more pieces to add everything.";
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  function refreshAddAll() {
    Array.prototype.forEach.call(document.querySelectorAll(PANELS), refreshPanel);
  }

  document.addEventListener("change", function (event) {
    var select = event.target;
    if (!select.matches || !select.matches("[data-mm-look-select]")) return;

    var row = select.closest("[data-mm-look-item]");
    if (!row) return;

    var btn = row.querySelector("[data-mm-look-add]");
    if (btn) {
      btn.setAttribute("data-mm-look-add", select.value || "");
      btn.disabled = !select.value;
    }

    var panel = row.closest(PANELS);
    if (panel) refreshPanel(panel);
    else refreshAddAll();
  });

  /* --------------------------------------------------------------------- */
  /* Preview switch                                                         */
  /* --------------------------------------------------------------------- */

  var PREVIEW_KEY = "mm-looks-preview";

  function readPreviewParam() {
    try {
      var v = new URLSearchParams(window.location.search).get("mm_looks");
      if (v === "1") sessionStorage.setItem(PREVIEW_KEY, "1");
      else if (v === "0") sessionStorage.removeItem(PREVIEW_KEY);
    } catch (e) {}
  }

  function previewOn() {
    try { return sessionStorage.getItem(PREVIEW_KEY) === "1"; } catch (e) { return false; }
  }

  function revealPreview() {
    if (!previewOn()) return;
    Array.prototype.forEach.call(
      document.querySelectorAll("[data-mm-looks-preview][hidden]"),
      function (b) { b.hidden = false; }
    );
  }

  /* --------------------------------------------------------------------- */
  /* Per-photo drawers                                                      */
  /* --------------------------------------------------------------------- */

  var openPanel = null;
  var returnFocus = null;

  /* Move the drawers out of their <template> and next to the gallery, inside
     .mm-scope so the drawer styles in mm-shop.css / mm-look.css apply. */
  function mount() {
    Array.prototype.forEach.call(document.querySelectorAll("template[data-mm-looks-tpl]"), function (tpl) {
      var host = tpl.closest(".mm-scope") || document.body;
      host.appendChild(tpl.content.cloneNode(true));
      tpl.parentNode.removeChild(tpl);
    });
    refreshAddAll();
  }

  function panelFor(id) {
    var sel = '[data-mm-looks-panel="' + String(id).replace(/"/g, "") + '"]';
    var panel = document.querySelector(sel);
    if (!panel) { mount(); panel = document.querySelector(sel); }
    return panel;
  }

  function scrim() { return document.querySelector("[data-mm-looks-scrim]"); }

  function stops(el) {
    return Array.prototype.slice.call(
      el.querySelectorAll('a[href], button:not([disabled]), select, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (n) { return n.offsetParent !== null; });
  }

  function setButtons(id, open) {
    Array.prototype.forEach.call(document.querySelectorAll("[data-mm-looks-open]"), function (b) {
      b.setAttribute("aria-expanded", open && b.getAttribute("data-mm-looks-open") === id ? "true" : "false");
    });
  }

  function closeLooks() {
    if (!openPanel) return;
    var panel = openPanel;
    openPanel = null;
    panel.setAttribute("data-open", "false");
    panel.removeAttribute("aria-modal");
    panel.inert = true;
    var s = scrim();
    if (s) s.setAttribute("data-open", "false");
    document.body.classList.remove("mm-no-scroll");
    setButtons("", false);
    var back = returnFocus;
    returnFocus = null;
    if (back && document.contains(back) && back.focus) back.focus({ preventScroll: true });
  }

  function openLooks(id, opener) {
    var panel = panelFor(id);
    if (!panel) return;
    if (openPanel && openPanel !== panel) closeLooks();
    returnFocus = opener || document.activeElement;
    openPanel = panel;
    panel.inert = false;
    panel.setAttribute("data-open", "true");
    panel.setAttribute("aria-modal", "true");
    var s = scrim();
    if (s) s.setAttribute("data-open", "true");
    document.body.classList.add("mm-no-scroll");
    setButtons(id, true);
    refreshPanel(panel);
    window.requestAnimationFrame(function () {
      var target = panel.querySelector("[data-mm-looks-close]") || stops(panel)[0];
      if (target && target.focus) target.focus({ preventScroll: true });
    });
  }

  /* Capture phase, like the cart and carousel handlers: Barba and the zoom
     viewer both listen on the document too. */
  document.addEventListener("click", function (event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var opener = t.closest("[data-mm-looks-open]");
    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      openLooks(opener.getAttribute("data-mm-looks-open"), opener);
      return;
    }
    if (openPanel && (t.closest("[data-mm-looks-close]") || t.closest("[data-mm-looks-scrim]"))) {
      event.preventDefault();
      closeLooks();
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    if (!openPanel) return;
    if (event.key === "Escape") { closeLooks(); return; }
    if (event.key !== "Tab") return;
    var list = stops(openPanel);
    if (!list.length) { event.preventDefault(); return; }
    var idx = list.indexOf(document.activeElement);
    if (event.shiftKey && idx <= 0) { event.preventDefault(); list[list.length - 1].focus(); }
    else if (!event.shiftKey && (idx === -1 || idx === list.length - 1)) { event.preventDefault(); list[0].focus(); }
  });

  /* --------------------------------------------------------------------- */

  function init() {
    readPreviewParam();
    revealPreview();
    refreshAddAll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

  /* Barba swaps the main container, bringing a fresh PDP with it. Only the
     preview reveal needs repeating, and only while preview is on. */
  var pending = null;
  new MutationObserver(function () {
    if (!previewOn()) return;
    if (pending) window.clearTimeout(pending);
    pending = window.setTimeout(revealPreview, 80);
  }).observe(document.body, { childList: true, subtree: true });
}());
